<a class="notifications-icon">
  <img src="{{ images.notifications }}" alt="{{ 'notifications' }}" (click)="chageShowNotifications(true)" *ngIf="!showNotifications">
  <img src="{{ images.notifications_open }}" alt="{{ 'notifications' }}" (click)="chageShowNotifications(false)" *ngIf="showNotifications">
  <p>{{ notifications.length }}</p>
</a>
<div id="div-notifications-container" class="div-notifications-container bg {{ animation }}" *ngIf="showNotifications">
  <h1 class="title-notifitacion" *ngIf="notifications.length === 0">No hay notificaciones</h1>
  <app-button [type]="'button'" *ngIf="notifications.length === 0" [classCss]="''" [text]="'commons.close'" (click)="chageShowNotifications(false)"></app-button>
  <div class="div-notification-container" *ngFor="let not of notifications; let i = index">
    <div class="div-notification {{ not.className }} {{ not.animation }}" (click)="closeNotification(i)">
      <div class="div-img">
        <img alt="{{ not.image }}" src="{{ not.image }}">
      </div>
      <div class="div-text">
        <h1>{{ not.title | translatePipe }}</h1>
        <p>{{ not.message | translatePipe }}</p>
      </div>
    </div>
  </div>
</div>
